import React, { useState, useEffect } from 'react';
import RiskForm from '../components/risk/RiskForm';
import RiskResult from '../components/risk/RiskResult';
import { useApi } from '../hooks/useApi';

const RiskAssessment = () => {
  const { post, get, loading, error } = useApi();
  const [result, setResult] = useState(null);
  const [calculatedMetrics, setCalculatedMetrics] = useState(null);

  // Check if user already has a profile
  useEffect(() => {
    const loadExisting = async () => {
      try {
        const profile = await get('/risk/profile');
        if (profile) {
          setResult({
            riskScore: profile.riskScore,
            riskCategory: profile.riskCategory,
            recommendedAllocation: profile.recommendedAllocation,
            breakdown: profile.breakdown,
          });
          setCalculatedMetrics(profile.metrics);
        }
      } catch {
        // No profile yet
      }
    };
    loadExisting();
  }, [get]);

  const handleSubmit = async (data) => {
    try {
      // New API expects: age, annualIncome, monthlyExpenses, investmentHorizonYears
      const response = await post('/risk/assess', {
        age: parseInt(data.age),
        annualIncome: parseInt(data.annualIncome),
        monthlyExpenses: parseInt(data.monthlyExpenses),
        investmentHorizonYears: parseInt(data.investmentHorizonYears),
      });
      setResult({
        riskScore: response.riskScore,
        riskCategory: response.riskCategory,
        recommendedAllocation: response.recommendedAllocation,
        breakdown: response.breakdown,
      });
      setCalculatedMetrics(response.metrics);
    } catch {
      // error is set by useApi
    }
  };

  const handleRetake = () => {
    setResult(null);
    setCalculatedMetrics(null);
  };

  return (
    <div className="max-w-2xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-gray-900 mb-2">Risk Assessment</h1>
      <p className="text-gray-500 mb-6">
        Understand your financial risk profile using our quantitative 4-factor model based on age, income, expenses, and investment horizon.
      </p>

      {result ? (
        <>
          <RiskResult result={result} metrics={calculatedMetrics} />
          <button
            onClick={handleRetake}
            className="mt-6 px-4 py-2 bg-gray-200 hover:bg-gray-300 text-gray-800 rounded-lg transition-colors"
          >
            Retake Assessment
          </button>
        </>
      ) : (
        <>
          {error && (
            <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-lg text-red-800">
              <p className="font-semibold">Error</p>
              <p className="text-sm">{error}</p>
            </div>
          )}
          <RiskForm onSubmit={handleSubmit} loading={loading} />
        </>
      )}
    </div>
  );
};

export default RiskAssessment;
